import React, { FC, useEffect } from 'react';
import { Outlet, useParams } from 'react-router';

import { useAppSelector } from '@/shared/hooks';
import { normalizeEmail } from '@/shared/lib';
import { Layout } from '@/shared/ui';

import { authModel } from '@/entities/auth';
import { useAccountInfoStream } from '@/entities/billing';
import { useOrganizationListStream } from '@/entities/organizations';
import { userModel } from '@/entities/user';

import { Footer } from '@/widgets/footer';
import { Header } from '@/widgets/header';

import { useOrganizationStream } from './hooks';

export const OrganizationContainer: FC = () => {
  const { organizationID } = useParams<{ organizationID: string }>();

  const isDistributorView = useAppSelector(
    authModel.selectors.selectIsDistributorView,
  );
  const adminDistributorEmail = useAppSelector(
    userModel.selectors.selectAdminDistributorEmail,
  );

  useOrganizationStream(organizationID);
  useAccountInfoStream(organizationID);

  const { openOrganizationListStream, closeOrganizationListStream } =
    useOrganizationListStream();

  // The reduced distributor view reads the organization from the list slice,
  // which only the distributor clients stream fills in.
  useEffect(() => {
    if (!isDistributorView) {
      return undefined;
    }

    openOrganizationListStream({
      search: '',
      filter: {
        case: 'ShowDistributorClients',
        value: {
          DistributorOwnerEmail: adminDistributorEmail
            ? normalizeEmail(adminDistributorEmail)
            : undefined,
        },
      },
    });

    return () => {
      closeOrganizationListStream();
    };
  }, [
    isDistributorView,
    adminDistributorEmail,
    openOrganizationListStream,
    closeOrganizationListStream,
  ]);

  return (
    <Layout>
      <Header />
      <Outlet />
      <Footer />
    </Layout>
  );
};
